import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from '@apollo/client';
//import FirmSubUsers from './FirmSubUsers';
//import ThemeContext from "../../context/ThemeContext";
import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from "../../../../../context/UserContext";
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { Link, useNavigate } from "react-router-dom";
import { TabView, TabPanel } from 'primereact/tabview';
import { RadioButton } from "primereact/radiobutton";
import { Dialog } from 'primereact/dialog';

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';
import HtlRoomFactor from "./HtlRoomFactor";

const GET_POST = gql`
  query MyQuery12( $firmSubCode: String!, $rTypeCode: String!, $firmMainCode: String!) {
    tbl_htl_room_type(
      where: {
        firm_main_code: { _eq: $firmMainCode},
        firm_sub_code: { _eq: $firmSubCode },
        r_type_code: { _eq: $rTypeCode }
      }
    ) {
      firm_main_code
      firm_sub_code
      r_class_code
      r_type_code
      r_type_name
      bed_type
      bed
      min_pax
      max_pax
      min_adl
      max_adl
      min_chl
      max_chl
      total_room
      baby_start
      baby_end
      chl_start
      chl_end
      int_ID
      active
      base_price_persent
    }
  }
`;

const GET_RCLASS = gql`
  query MyQuery($drctype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drctype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;


const GET_RTTYPE = gql`
  query MyQuery($drttype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drttype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;

const GET_RBTYPE = gql`
  query MyQuery($drbtype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drbtype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;


const UPDATE_RTYPE = gql`
mutation UpdateRoomType(
  $firmSubCode: String!
  $rClassCode: String!
    $rTypeCode: String!
    $rTypeName: String!
    $rBedType: String!
    $rBed: Int!
    $minPax: Int!
    $maxPax: Int!
   
    $minAdl: Int!
    $maxAdl: Int!
    $minChl: Int!
    $maxChl: Int!
    $totalRoom:Int!
    $babyStart: float8!
    $babyEnd: float8!
    $chlStart: float8!
    $chlEnd: float8!
    $active: Boolean!
    $basePricePers: Int
) {
  update_tbl_htl_room_type(
    where: {
        firm_sub_code: { _eq: $firmSubCode },
        r_type_code: { _eq: $rTypeCode }
    },
    _set: {
      r_type_name: $rTypeName,
      r_type_code: $rTypeCode,
      r_class_code: $rClassCode,
      bed_type: $rBedType,
      bed: $rBed,
      min_pax: $minPax,
      max_pax: $maxPax,
      min_adl: $minAdl,
      max_adl: $maxAdl,
      min_chl: $minChl,
      max_chl: $maxChl,
      total_room: $totalRoom,
      baby_start: $babyStart,
      baby_end: $babyEnd,
      chl_start: $chlStart,
      chl_end: $chlEnd,
      active: $active,
      base_price_persent: $basePricePers,
    }
  ) {
    affected_rows
  }
}
`;

const INSERT_RTYPE = gql`
  mutation InsertRoomType(
    $firmMainCode: String!
    $firmSubCode: String!
    $rClassCode: String!
    $rTypeCode: String!
    $rTypeName: String!
    $rBedType: String!
    $rBed: Int!
    $minPax: Int!
    $maxPax: Int!
    $minAdl: Int!
    $maxAdl: Int!
    $minChl: Int!
    $maxChl: Int!
    $totalRoom: Int!
    $babyStart: float8!
    $babyEnd: float8!
    $chlStart: float8!
    $chlEnd: float8!
    $basePricePers: Int
  ) {
    insert_tbl_htl_room_type(
      objects: {
        firm_main_code: $firmMainCode,
        firm_sub_code: $firmSubCode,
        r_class_code: $rClassCode,
        r_type_code: $rTypeCode,
        r_type_name: $rTypeName,
        bed_type: $rBedType,
        bed: $rBed,
        min_pax: $minPax,
        max_pax: $maxPax,
        min_adl: $minAdl,
        max_adl: $maxAdl,
        min_chl: $minChl,
        max_chl: $maxChl,
        total_room: $totalRoom,
        baby_start: $babyStart,
        baby_end: $babyEnd,
        chl_start: $chlStart,
        chl_end: $chlEnd,
        base_price_persent: $basePricePers,
      }
    ) {
      affected_rows
    }
  }
`;









const HtlHotelRoomTypeEdit = () => {


  const { theme, setTheme } = useContext(ThemeContext);
  const { varCode, setVarCode } = useContext(ThemeContext);
  const { varCode2, setVarCode2 } = useContext(ThemeContext);
  const { users } = useContext(UserContext);
  const firmMainCode = users.firmcode;
  const firmSubCode = users.subfirmcode;
  const { r_type_code } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { firmSubCode: firmSubCode, firmMainCode: firmMainCode, rTypeCode: r_type_code },
  });
  const [UpdateRoomType] = useMutation(UPDATE_RTYPE);
  const [InsertRoomType] = useMutation(INSERT_RTYPE);

  const firmData = data && data.tbl_htl_room_type ? data.tbl_htl_room_type[0] : null;

 

  
  const [rClassName, setRClassName] = useState(firmData ? firmData.r_class_name : "");
  const [rClassCode, setRClassCode] = useState(firmData ? firmData.r_class_name : "");
  const [rTypeCode, setRTypeCode] = useState(firmData ? firmData.r_type_code : "");
  const [rTypeName, setRTypeName] = useState(firmData ? firmData.r_type_name : "");
  const [rBedType, setRBedType] = useState(firmData ? firmData.bed_type : "");
  const [rBed, setBed] = useState(firmData ? firmData.bed : "");
  const [minPax, setMinPax] = useState(firmData ? firmData.min_pax : "");
  const [maxPax, setMaxPax] = useState(firmData ? firmData.max_pax: "");
  const [minAdl, setMinAdl] = useState(firmData ? firmData.min_adl : "");
  const [maxAdl, setMaxAdl] = useState(firmData ? firmData.max_adl: "");
  const [minChl, setMinChl] = useState(firmData ? firmData.min_chl : "");
  const [maxChl, setMaxChl] = useState(firmData ? firmData.max_chl : "");
  const [totalRoom, setTotalRoom] = useState(firmData ? firmData.total_room : "");
  const [babyStart, setBabyStart] = useState(firmData ? firmData.baby_start : "");
  const [babyEnd, setBabyEnd] = useState(firmData ? firmData.baby_end : "");
  const [chlStart, setChlStart] = useState(firmData ? firmData.chl_start : "");
  const [chlEnd, setChlEnd] = useState(firmData ? firmData.chl_end : "");
  const [rIntId, setRIntId] = useState(firmData ? firmData.int_ID : "");
  const [active, setActive] = useState(firmData ? firmData.active : true);
  const [basePricePers, setBasePricePers] = useState(firmData ? firmData.base_price_persent : "");


  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  const close_form = messages[currentLocale].close_form;
  
  const typerec = messages[currentLocale].typerec;
  
  const updaterec = messages[currentLocale].updaterec;
  const int_id = messages[currentLocale].int_id;
  const select_a_room_class = messages[currentLocale].select_a_room_class;
  const select_a_room_type = messages[currentLocale].select_a_room_type;
  const select_a_bed_type = messages[currentLocale].select_a_bed_type;
  
 
  const create_room_typerec = messages[currentLocale].create_room_typerec;
  
  const managing_hotel = messages[currentLocale].managing_hotel;
  
  const room_class_tab = messages[currentLocale].room_class_tab;
  const room_type_tab = messages[currentLocale].room_type_tab;
  const room_class_code = messages[currentLocale].room_class_code;
  
  const room_bed_title = messages[currentLocale].room_bed_title;
  const room_bed_type_title = messages[currentLocale].room_bed_type_title;
  const room_total_title = messages[currentLocale].room_total_title;
  const room_max_pax_title = messages[currentLocale].room_max_pax_title;
  const room_min_pax_title = messages[currentLocale].room_min_pax_title;
  const room_chl_max_title = messages[currentLocale].room_chl_max_title;
  const room_chl_min_title = messages[currentLocale].room_chl_min_title;
  const room_baby_start_title = messages[currentLocale].room_baby_start_title;
  const room_baby_end_title = messages[currentLocale].room_baby_end_title;
  const room_chl_start_title = messages[currentLocale].room_chl_start_title;
  const room_chl_end_title = messages[currentLocale].room_chl_end_title;
  

  const administrator = messages[currentLocale].administrator;
  const dashboard = messages[currentLocale].dashboard
  const room_person_factor_title = messages[currentLocale].room_person_factor_title;
  const room_base_realtion = messages[currentLocale].room_base_realtion;

  

  

  


  
  const { loading: drtLoading, error: drtError, data: drtData } = useQuery(GET_RTTYPE, {
    variables: { drttype: 'RTYP', lang: currentLocale },
  });

  const { loading: drcLoading, error: drcError, data: drcData } = useQuery(GET_RCLASS, {
    variables: { drctype: "RCLS", lang: currentLocale },
  });

  const { loading: drbLoading, error: drbError, data: drbData } = useQuery(GET_RBTYPE, {
    variables: { drbtype: "BTYP", lang: currentLocale },
  });

  const roomClassSelectItemsC = drcData && drcData.tbl_gnl_def
  ? drcData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const roomClassSelectItems = drtData && drtData.tbl_gnl_def
  ? drtData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const roomClassSelectItemsB = drbData && drbData.tbl_gnl_def
  ? drbData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const [displayBasic, setDisplayBasic] = useState(false);

  const onClick = () => {
    setVarCode(rTypeCode);
    setDisplayBasic(true);
    refetch();
  };

  const onHide = () => {
    setDisplayBasic(false);
    refetch();
    
  };
  

  

  
  

  
  
  
  const [firmType, setFirmType] = useState(firmData ? firmData.firm_type : "");  
  
  console.log("Firm Data:", firmData);

  
  

  useEffect(() => {
    if (drtData && drtData.tbl_gnl_def) {
      const selectedRoomClass = drtData.tbl_gnl_def.find(item => item.code === rTypeCode);
      if (selectedRoomClass) {
        setRTypeName(selectedRoomClass.name);
      }
    }
  }, [rTypeCode, drtData]);

  useEffect(() => {
    if (firmData) {
      setRClassName(firmData.r_class_name);
      setRClassCode(firmData.r_class_code);
      setRTypeCode(firmData.r_type_code);
      setRTypeName(firmData.r_type_name);
      setRBedType(firmData.bed_type);
      setBed(firmData.bed);
      setMinPax(firmData.min_pax);
      setMaxPax(firmData.max_pax);
      setMinAdl(firmData.min_adl);
      setMaxAdl(firmData.max_adl);
      setMinChl(firmData.min_chl);
      setMaxChl(firmData.max_chl);
      
      setTotalRoom(firmData.total_room);
      setBabyStart(firmData.baby_start);
      setBabyEnd(firmData.baby_end);
      setChlStart(firmData.chl_start);
      setChlEnd(firmData.chl_end);
      setRIntId(firmData.int_ID);
      setActive(firmData.active);
      setBasePricePers(firmData.base_price_persent);
      
    }
  }, [firmData]);

  const handleUpdate = () => {
    UpdateRoomType({
      variables: {
        firmSubCode: firmSubCode,
        rClassCode: rClassCode,
        rTypeCode: rTypeCode,
        rTypeName: rTypeName,
        rBedType: rBedType,
        rBed: rBed,
        minPax: minPax,
        maxPax: maxPax,
        minAdl: minAdl,
        maxAdl: maxAdl,
        minChl: minChl,
        maxChl:maxChl,
        totalRoom:totalRoom,
        babyStart: babyStart,
        babyEnd: babyEnd,
        chlStart: chlStart,
        chlEnd: chlEnd,
        active: active,
        basePricePers: basePricePers,

        
      },
    })
      .then(() => {
        window.alert("Room Type updated successfully!");
        refetch();
       
      })
      .catch((error) => {
        console.error("Error updating Room Type:", error);
      });
  };

  const handleInsert = () => {
    InsertRoomType({
      variables: {
        firmSubCode: firmSubCode,
        firmMainCode: firmMainCode,
        rClassCode: rClassCode,
        rTypeCode: rTypeCode,
        rTypeName: rTypeName,
        rBedType: rBedType,
        rBed: rBed,
        totalRoom: totalRoom,
        minPax: minPax,
        maxPax: maxPax,
        minAdl: minAdl,
        maxAdl: maxAdl,
        minChl: minChl,
        maxChl: maxChl,
        babyStart: babyStart,
        babyEnd: babyEnd,
        chlStart: chlStart,
        chlEnd: chlEnd,
        rIntId: rIntId,
        basePricePers: basePricePers,
      },
    })
      .then(() => {
        window.alert("Firm insert successfully!");
      })
      .catch((error) => {
        console.error("Error inserting firm:", error);
        const pkError = error.graphQLErrors.some(err => 
          err.message.includes("duplicate key value") || err.extensions.code === "23505" // PostgreSQL unique violation code
        );
        
        if (pkError) {
          setErrorType("PK_ERROR");
        } else {
          setErrorType("GENERAL_ERROR");
        }
        setDialogVisible(true); // Hata durumunda dialogu aç
      });
  };

  const [dialogVisible, setDialogVisible] = useState(false);
  const [errorType, setErrorType] = useState("");

  const hideDialog = () => {
    setDialogVisible(false);
  };

  const getErrorMessage = () => {
    switch (errorType) {
      case "PK_ERROR":
        return "Bu kayıt daha önce eklenmiştir.";
      default:
        return "Bir hata oluştu. Lütfen tekrar deneyin.";
    }
  };

  if (loading) return <p>Loading...</p>;
if (error) return <p>Error: {error.message}</p>;

const items = [{ label: dashboard ,url: "/", target: '_self'},  { label: administrator ,url:"/htl/hotel-adm/main" }, { label: managing_hotel ,url:"/htl/hotel-adm/accomodation/room-type-list" }, { label: managing_hotel }];

return (

  


    
<div className="container p-2 mx-auto sm:p-4 dark:text-gray-100">
    <div className="grid grid-cols-3 gap-4">
      <div className="col-span-2 w-5/6">
        <nav>
          <ul className="flex border-solid rounded-md border-b outline-1">
            {items.map((item, index) => (
              <li key={index} className={`flex items-center m-1 ${index === items.length - 1 ? 'font-normal' : ''}`}>
                {index !== 0 && <span className={`mx-3 ${index === items.length - 1 ? '' : 'font-light'}`}> &gt; </span>}
                {item.url ? (
                  <Link to={item.url}>{item.label}</Link>
                ) : (
                  <span>{item.label}</span>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className="col-span-1 mr-5 flex justify-end">
     
      <button onClick={() => navigate(-1)} className="text-violet-900 hover:text-violet-200 font-bold">{close_form}</button>
   
      </div>
     
  
    </div> 

    <div className="card mt-5 min-h-[40em]">

    <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTab} onTabChange={(e) => handleTabChange(e.index)}>
   <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {<FormattedMessage id="room_type_detail_title" />}
            </span>
          }
          className="ml-5 flex"
        >
  
        
  <div className="container flex-col p-2 mx-auto sm:p-4 dark:text-gray-100">
    

    <div className="flex">
  <div className="mr-2 w-1/6">
    <label htmlFor="firmType" className="block font-medium text-gray-700">
      {room_class_code}
    </label>
    <input
      type="text"
      id="firmType"
      name="firmType"
      value={rClassCode}
      onChange={(e) => setRClassCode(e.target.value)}
      className="mt-1 px-4 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full rounded-md"
      readOnly
    />
  </div>

  <div>
    <label htmlFor="roomClassDropdown" className="block font-medium text-gray-700">
      {room_class_tab}
    </label>
    <Dropdown
      className="h-11  w-56 md:w-56 mr-2 rounded-md"
      style={{ flex: '3' }}
      value={rClassCode}
      options={roomClassSelectItemsC}
      onChange={(e) => setRClassCode(e.value)}
      placeholder={select_a_room_class}
    />
  </div>

  <div className="mr-2 w-1/8">
    <label htmlFor="firmType" className="block font-medium text-gray-700">
      {typerec}
    </label>
    <input
      type="text"
      id="firmType"
      name="firmType"
      value={rTypeCode}
      onChange={(e) => setRTypeCode(e.target.value)}
      className="mt-1 px-4 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full rounded-md"
      readOnly
    />
  </div>

  <div>
    <label htmlFor="roomClassDropdown" className="block font-medium text-gray-700">
      {room_type_tab}
    </label>
    <Dropdown
      className="h-11 w-3/8 rounded-md"
      style={{ flex: '2' }}
      value={rTypeCode}
      options={roomClassSelectItems}
      onChange={(e) => setRTypeCode(e.value)}
      placeholder={select_a_room_type}
    />
  </div>
  <label htmlFor="firmtype" 
  className="mb-2 block font-medium text-gray-950">Status </label><p></p>
  <div className="flex mt-5 ml-0 flex-wrap gap-6">
  <div className="flex ml-0 mt-2 align-items-center">
  <RadioButton inputId="ingredient1" name="active" value={true}  onChange={(e) => setActive(e.value)} checked={active === true} />
          <label htmlFor="ingredient1" className="ml-2">Active</label>
          
      </div>
      <div className="flex align-items-center mt-2">
          <RadioButton inputId="ingredient2" name="inactive" value={false}  onChange={(e) => setActive(e.value)} checked={active === false} />
          <label htmlFor="ingredient2" className="ml-2">Inactive</label>
      </div>
      
  </div>

</div>

<div className="flex mb-4">
  <div className="mt-4 w-1/3 pr-4">
    <label htmlFor="firmName" className="block font-medium text-gray-700">
      {room_type_tab}
    </label>
    <input
      type="text"
      id="firmName"
      name="firmName"
      value={rTypeName}
      onChange={(e) => setRTypeName(e.target.value)}
      className="mt-1 px-4 py-2 border w-full border-gray-300 focus:ring-blue-500 focus:border-blue-500 block rounded-md"
    />
  </div>

  <div className="mt-4 w-1/6 pr-4">
    <label htmlFor="roomClassDropdown" className="block font-medium text-gray-700">
      {room_bed_type_title}
    </label>
    <Dropdown
      className="w-full rounded-md"
      value={rBedType}
      options={roomClassSelectItemsB}
      onChange={(e) => setRBedType(e.value)}
      placeholder={select_a_bed_type}
    />
  </div>



  <div className="flex-auto mr-4 ml-2 mt-4 w-1/6">
  <label htmlFor="integeronly" className="font-medium block mb-1">{room_bed_title}</label>
  <InputNumber 
    inputId="integeronly"
    value={rBed} 
    onValueChange={(e) => setBed(e.value)}
    className="w-full h-11  border-gray-300 rounded-md "
  />
</div>

  <div className="flex-auto mr-4 ml-2 mt-4 w-2/6">
  <label htmlFor="integeronly" className="font-medium block mb-1">{room_total_title}</label>
  <InputNumber 
    inputId="integeronly"
    value={totalRoom} 
    onValueChange={(e) => setTotalRoom(e.value)}
    className="w-full h-11  border-gray-300 rounded-md "
  />
</div>
</div>




<div className="grid grid-cols-6">
  <div className="col-span-1">
    <div className="mr-2 inputtext ml-2"> {/* Genişliği 36rem veya uygun bir değer olarak ayarlayabilirsiniz */}
      <label htmlFor="minPax" className="font-medium">{room_min_pax_title}</label>
      <InputNumber 
        inputId="minPax"
        value={minPax} 
        onValueChange={(e) => setMinPax(e.value)}
        className="h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
        
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className="mr-2 ml-2">
      <label htmlFor="maxPax" className="font-medium block">{room_max_pax_title}</label>
      <InputNumber 
        inputId="maxPax"
        value={maxPax} 
        onValueChange={(e) => setMaxPax(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className=" mr-2 ml-2">
      <label htmlFor="minAdl" className="font-medium block">Min Adl</label>
      <InputNumber 
        inputId="minAdl"
        value={minAdl} 
        onValueChange={(e) => setMinAdl(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className="mr-2 ml-2">
      <label htmlFor="maxAdl" className="font-medium block">Max Adl</label>
      <InputNumber 
        inputId="maxAdl"
        value={maxAdl} 
        onValueChange={(e) => setMaxAdl(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className="mr-2 ml-2">
      <label htmlFor="minChl" className="font-medium block">{room_chl_min_title}</label>
      <InputNumber 
        inputId="minChl"
        value={minChl} 
        onValueChange={(e) => setMinChl(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className="mr-2 ml-2">
      <label htmlFor="maxChl" className="font-medium">{room_chl_max_title}</label>
      <InputNumber 
        inputId="maxChl"
        value={maxChl} 
        onValueChange={(e) => setMaxChl(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
      />
    </div>
  </div>
</div>

<div className="grid grid-cols-5 mt-4">
  <div className="col-span-1">
    <div className="mr-2 inputtext ml-2"> {/* Genişliği 36rem veya uygun bir değer olarak ayarlayabilirsiniz */}
      <label htmlFor="minPax" className="font-medium"> {room_baby_start_title}</label>
      <InputNumber 
        inputId="minPax"
        value={babyStart} 
        onValueChange={(e) => setBabyStart(e.value)}
        className="h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
        
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className="mr-2 ml-2">
      <label htmlFor="maxPax" className="font-medium block"> {room_baby_end_title}</label>
      <InputNumber 
        inputId="maxPax"
        value={babyEnd} 
        onValueChange={(e) => setBabyEnd(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}        
        maxFractionDigits={2}
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className=" mr-2 ml-2">
      <label htmlFor="minAdl" className="font-medium block">{room_chl_start_title}</label>
      <InputNumber 
        inputId="minAdl"
        value={chlStart} 
        onValueChange={(e) => setChlStart(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
        maxFractionDigits={2}
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className="mr-2 ml-2">
      <label htmlFor="maxAdl" className="font-medium block"> {room_chl_end_title}</label>
      <InputNumber 
        inputId="locale-user"
        value={chlEnd} 
        onValueChange={(e) => setChlEnd(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
        maxFractionDigits={2}
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className="mr-2 ml-2">
      <label htmlFor="minChl" className="font-medium block">{int_id}</label>
      <InputNumber 
        inputId="minChl"
        value={rIntId} 
        onValueChange={(e) => setRIntId(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
      />

      
    </div>
    
  </div>

  <div className="col-span-1">
    <div className="mr-2 ml-2">
      <label htmlFor="minChl" className="font-medium block">{room_base_realtion}</label>
      <InputNumber 
        inputId="minChl"
        value={basePricePers} 
        onValueChange={(e) => setBasePricePers(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
      />
    </div>
    
  </div>
</div>



    <div className="mt-4 flex justify-end">
    <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={onClick}
      >
        {'factor'}
      </button>
      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleUpdate}
      >
        {updaterec}
      </button>
      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleInsert}
      >
        {create_room_typerec}
      </button>
    </div>
  </div>
  <Dialog header="Hata" style={{ width: '40vw' }} visible={dialogVisible} onHide={hideDialog}>
  <div className="flex flex-col items-center text-center p-6">
          <div className="bg-red-100 rounded-full p-4 mb-4">
            <svg className="w-12 h-12 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </div>
          <h2 className="text-2xl font-semibold text-red-500 mb-2">Error</h2>
          <p className="text-gray-600 mb-6">{getErrorMessage()}</p>
          <button onClick={hideDialog} className="bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded">
            TRY AGAIN
          </button>
        </div>
      </Dialog>

  <Dialog visible={displayBasic} style={{ width: '60vw' }} onHide={onHide} header={room_person_factor_title}>
  <div className={`modal-backdrop bg-slate-600  ${displayBasic ? 'block' : 'hidden'}`}></div>
  <div>
    <p>
    <HtlRoomFactor/>
    </p>
  </div>
</Dialog>

  </TabPanel>

  <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {<FormattedMessage id="room_type_property_title" />}
            </span>
          }
          className="ml-5 flex"
        >
            "dsjkdjsldjsl"

  </TabPanel>

  <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 2 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {<FormattedMessage id="room_list_title" />}
            </span>
          }
          className="ml-5 flex"
        >
            "dsjkdjsldjsl"

  </TabPanel>

  <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 3 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {<FormattedMessage id="room_type_building_list" />}
            </span>
          }
          className="ml-5 flex"
        >
            "dsjkdjsldjsl"

  </TabPanel>

  <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 4 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {<FormattedMessage id="room_type_departments_title" />}
            </span>
          }
          className="ml-5 flex"
        >
            "dsjkdjsldjsl"

  </TabPanel>

</TabView>
  </div>
  </div>
);
};

export default HtlHotelRoomTypeEdit;
